
import DefaultModal from 'components/Modals/DefaultModal';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import VitalSignItem from 'components/VitalSignItem';
import useTestTypes from 'hooks/useTestTypes';

const ViewTestResult = ({ closeModal, test }) => {
    const signStyle = `border-b border-b-neutral_stroke_2`
    const { tests, updateTest } = useTestTypes()

    useEffect(() => {
        updateTest(test?.testType, test?.testProperties)
    }, [])

    return (
        <DefaultModal
            closeModal={closeModal}
            styles="w-full md:w-[457px]"
            position="modal-right"
            variant="py-[14.5px] px-[24px] text-left border-b border-b-neutral_stroke_2 text-16 font-campton_m capitalize"
            title={test.testType}
        >
            <div className="modal-right-body mt-2">
                <div>
                    {test?.testResult?.map(item => <img key={item} src={item} className="w-full h-auto mb-[24px]" />)}
                </div>
                {tests.filter(t => t.value !== '').map(item =>
                    <VitalSignItem
                        key={item?.name}
                        name={item?.name}
                        value={item?.value}
                        label={item?.unit}
                        className={signStyle}
                    />
                )}
                {test?.testProperties &&
                    <div className="mt-[16px] flex">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 0.875C7.39303 0.875 5.82214 1.35152 4.486 2.24431C3.14985 3.1371 2.10844 4.40605 1.49348 5.8907C0.87852 7.37535 0.717618 9.00901 1.03112 10.5851C1.34463 12.1612 2.11846 13.6089 3.25476 14.7452C4.39106 15.8815 5.8388 16.6554 7.4149 16.9689C8.99099 17.2824 10.6247 17.1215 12.1093 16.5065C13.594 15.8916 14.8629 14.8502 15.7557 13.514C16.6485 12.1779 17.125 10.607 17.125 9C17.1227 6.84581 16.266 4.78051 14.7427 3.25727C13.2195 1.73403 11.1542 0.877275 9 0.875ZM9 15.875C7.64026 15.875 6.31105 15.4718 5.18046 14.7164C4.04987 13.9609 3.16868 12.8872 2.64833 11.6309C2.12798 10.3747 1.99183 8.99237 2.2571 7.65875C2.52238 6.32513 3.17716 5.10013 4.13864 4.13864C5.10013 3.17716 6.32514 2.52237 7.65876 2.2571C8.99238 1.99183 10.3747 2.12798 11.631 2.64833C12.8872 3.16868 13.9609 4.04987 14.7164 5.18045C15.4718 6.31104 15.875 7.64025 15.875 9C15.8729 10.8227 15.1479 12.5702 13.8591 13.8591C12.5702 15.1479 10.8227 15.8729 9 15.875ZM10.25 12.75C10.25 12.9158 10.1842 13.0747 10.0669 13.1919C9.94974 13.3092 9.79076 13.375 9.625 13.375C9.29348 13.375 8.97554 13.2433 8.74112 13.0089C8.5067 12.7745 8.375 12.4565 8.375 12.125V9C8.20924 9 8.05027 8.93415 7.93306 8.81694C7.81585 8.69973 7.75 8.54076 7.75 8.375C7.75 8.20924 7.81585 8.05027 7.93306 7.93306C8.05027 7.81585 8.20924 7.75 8.375 7.75C8.70652 7.75 9.02447 7.8817 9.25889 8.11612C9.49331 8.35054 9.625 8.66848 9.625 9V12.125C9.79076 12.125 9.94974 12.1908 10.0669 12.3081C10.1842 12.4253 10.25 12.5842 10.25 12.75ZM7.75 5.5625C7.75 5.37708 7.80499 5.19582 7.908 5.04165C8.01101 4.88748 8.15743 4.76732 8.32874 4.69636C8.50004 4.62541 8.68854 4.60684 8.8704 4.64301C9.05226 4.67919 9.2193 4.76848 9.35042 4.89959C9.48153 5.0307 9.57082 5.19775 9.60699 5.3796C9.64316 5.56146 9.6246 5.74996 9.55364 5.92127C9.48268 6.09257 9.36252 6.23899 9.20835 6.342C9.05418 6.44502 8.87292 6.5 8.6875 6.5C8.43886 6.5 8.20041 6.40123 8.02459 6.22541C7.84878 6.0496 7.75 5.81114 7.75 5.5625Z" fill="#DC8E09" />
                        </svg>
                        <p className="text-14 text-[#DC8E09] font-campton_m ml-[9px]">This lab test result is critical and requires immediate attention.</p>
                    </div>
                }
            </div>
        </DefaultModal>

    );
};
export default ViewTestResult;
ViewTestResult.propTypes = {
    test: PropTypes.object,
    closeModal: PropTypes.func,
};